import { render } from "./NewsItem.vue?vue&type=template&id=30bec949"
import script from "./NewsItem.vue?vue&type=script&lang=js"
export * from "./NewsItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/NewsItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30bec949"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30bec949', __exports__)) {
    api.reload('30bec949', __exports__)
  }
  
  module.hot.accept("./NewsItem.vue?vue&type=template&id=30bec949", () => {
    api.rerender('30bec949', render)
  })

}


export default __exports__